import React, { useEffect, useState } from 'react';
import { Image } from 'primereact/image';

const ChatMessageBubble = (props) => {
  const [bubbleContent, setBubbleContent] = useState(null);
  const [chatterSettings, setChatterSettings] = useState(null);
  
  useEffect(() => {
    setBubbleContent(props.bubbleContent);
    setChatterSettings(props.chatterSettings);
  }, [props]);

  if (bubbleContent === null) {
    return <></>;
  }

  return (
    chatterSettings?.classic_message_layout === true ?
    <>
      <div className="chat-message-bubble-classic-container flex flex-row mt-2">
        <a href="#" className="flex flex-row no-underline" onClick={props.onClick}>
          <div className="chat-message-bubble-classic-inner flex flex-row gap-1 align-items-start">
            <div className="nickname text-primary">{bubbleContent.chatter.nickname}</div>
            {bubbleContent.chat_message.quoted_message !== null &&
            <div className={`flex flex-row align-items-center quoted-container gap-1 ${bubbleContent.quoted_my_message?'quoted-my-message':''}`}>
              <div className="quoted">回應</div>
              <div className="nickname">{bubbleContent.chat_message.quoted_message.chatter.nickname}</div>
            </div>
            }
            <div className="say">說：</div>
            <div className="message">{bubbleContent.chat_message.message}</div>
          </div>
        </a>
      </div>
    </>
    :
    <>
      <div className={`chat-message-bubble-container flex flex-row ${bubbleContent.own?'justify-content-end':''} flex pb-2`}>
        <div className={`chat-message-bubble-inner flex flex-column p-2 border-round-md shadow-1 ${bubbleContent.quoted_my_message?'quoted-my-message':''}`}>
          {bubbleContent.chat_message.quoted_message !== null &&
          <div className="quoted-message-contanier flex flex-row align-items-center mb-2 p-2 border-round-lg gap-2 chatroom-surface-200">
            <div className="quoted-message-inner flex-1 opacity-70 border-round-sm px-1" style={{ borderLeft: '5px solid #f55' }}>
              <div className="nickname text-xs text-primary mb-1">{bubbleContent.chat_message.quoted_message.chatter.nickname}</div>
              <div className="message">{bubbleContent.chat_message.quoted_message.chat_message.message}</div>
            </div>
          </div>}
          <a href="#" className="flex flex-row no-underline" onClick={props.onClick}>
            <div className="avatar pr-2">
              <Image src={`/avatar/${bubbleContent.chatter.avatar}.jpg`} alt="Image" width="30" imageClassName="border-round-md" />
            </div>
            <div className="main flex flex-column">
              <div className="nickname mb-1">
                <span className="name text-xs text-primary">{bubbleContent.chatter.nickname}</span>
                <span className="time text-xs ml-1" style={{ color:'#999' }}>{bubbleContent.chat_message.message_datetime.minitime}</span>
              </div>
              <div className="message">{bubbleContent.chat_message.message}</div>
              <div className="message-datetime text-xs hidden">{bubbleContent.chat_message.message_datetime.minitime}</div>
            </div>
          </a>
        </div>
      </div>
    </>
  );
};
  
export default ChatMessageBubble;
